import { getColor, getBackgroundColor } from '../../colors/colors.alias';
import { getOpacity } from '../../opacity/opacity.alias';
import getIcons from '../../icons/icons.alias';
import { constants as Input } from '../Input';
import { constants as Icon } from '../Icon';
import { constants as Label } from '../Label';
import { constants as InlineMessage } from '../InlineMessage';
import { constants as Datepicker } from '../Datepicker';
import { constants as Modal } from '../Modal';
import { VARIANT_DEFAULT, VARIANT_WITH_NATIVE_DATEPICKER, ELEMENT_LABEL, ELEMENT_INPUT, ELEMENT_PLACEHOLDER, ELEMENT_OPEN_DATEPICKER_BUTTON, ELEMENT_BACKDROP, ELEMENT_MODAL, ELEMENT_DATEPICKER, ELEMENT_INLINE_MESSAGE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, INTERACTION_STATE_DATEPICKER_OPEN, DATA_STATE_VALID, DATA_STATE_INVALID, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'DatepickerInput',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_WITH_NATIVE_DATEPICKER,
    },
    elements: {
        ELEMENT_LABEL,
        ELEMENT_INPUT,
        ELEMENT_PLACEHOLDER,
        ELEMENT_OPEN_DATEPICKER_BUTTON,
        ELEMENT_BACKDROP,
        ELEMENT_DATEPICKER,
        ELEMENT_INLINE_MESSAGE,
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
        INTERACTION_STATE_DATEPICKER_OPEN,
    },
});
export default function getDatepickerInput(transformer, config) {
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const opacity = getOpacity(transformer);
    const icons = getIcons();
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM,
                    },
                },
            },
            [ELEMENT_INPUT]: {
                components: {
                    [Input.NAME]: {
                        variant: Input.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_OPEN_DATEPICKER_BUTTON]: {
                styles: {
                    color: color.button.plain.icon.default.value,
                },
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_MEDIUM,
                        name: icons.action.openDatepicker.value,
                    },
                },
            },
            [ELEMENT_BACKDROP]: {
                styles: {
                    opacity: opacity.backdrop.value,
                    backgroundColor: backgroundColor.backdrop.value,
                },
            },
            [ELEMENT_MODAL]: {
                components: {
                    [Modal.NAME]: {
                        variant: Modal.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_INLINE_MESSAGE]: {
                components: {
                    [InlineMessage.NAME]: {
                        variant: InlineMessage.variants.VARIANT_DEFAULT,
                    },
                },
            },
        },
        variants: {
            [VARIANT_DEFAULT]: {
                elements: {
                    [ELEMENT_DATEPICKER]: {
                        components: {
                            [Datepicker.NAME]: {
                                variant: Datepicker.variants.VARIANT_DEFAULT,
                            },
                        },
                    },
                },
            },
            [VARIANT_WITH_NATIVE_DATEPICKER]: {
                elements: {
                    [ELEMENT_DATEPICKER]: {
                        components: {
                            [Datepicker.NAME]: {
                                variant: Datepicker.variants.VARIANT_NATIVE,
                            },
                        },
                    },
                },
            },
        },
    });
}
